import { useHistory } from "react-router";
import { useState } from "react";
import { useCreateStaticEquipment } from "../api/api";
import { StaticEquipmentPartial } from "./StaticEquipmentPartial";
import type { ShipRouteProps } from "../types/routes";
import type { ApiError, StaticEquipmentForm } from "../types/models";

export const StaticEquipmentNew = (props: ShipRouteProps) => {
  const { shipId } = props.match.params;
  const history = useHistory();

  const [editedEquipment, setEditedEquipment] = useState<StaticEquipmentForm>(
    {}
  );
  const [error, setError] = useState<ApiError | undefined>();

  const createStaticEquipment = useCreateStaticEquipment(shipId, {
    onSuccess: () => {
      history.push(`/ships/${shipId}/static-equipments/`);
    },
    onError: ((err: ApiError) => setError(err)) as () => void,
  }) as unknown as {
    mutate: (payload: StaticEquipmentForm) => void;
  };

  return (
    <StaticEquipmentPartial
      title="New static equipment"
      backLink={`/ships/${shipId}/static-equipments/`}
      submitButtonTitle="Create"
      editedEquipment={editedEquipment}
      error={error}
      setEditedEquipment={setEditedEquipment}
      onSubmitClick={() => {
        createStaticEquipment.mutate(editedEquipment);
      }}
    />
  );
};
